exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor-pointer[data-v-368d1c82]{cursor:pointer}", ""]);

// exports
